/**
 * @generated SignedSource<<423a9a0590e2bdd21db93a378cebf1e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigator_detailedViewData$data = {
  readonly id: string;
  readonly issues: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_issueResults" | "selectedIssue_issueNavigator">;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigator_detailedViewData";
};
export type main_issueNavigator_IssueNavigator_detailedViewData$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigator_detailedViewData$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_detailedViewData">;
};

import IssueNavigatorDetailedViewPaginationQuery_graphql from './IssueNavigatorDetailedViewPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "issues"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetIds"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "issueTypeId"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "projectId"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryFieldSetsById"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": IssueNavigatorDetailedViewPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "main_issueNavigator_IssueNavigator_detailedViewData",
  "selections": [
    {
      "alias": "issues",
      "args": [
        {
          "kind": "Variable",
          "name": "issueSearchInput",
          "variableName": "issueSearchInput"
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "__IssueNavigatorDetailedViewPagination__issues_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "cursor"
            },
            {
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "selectedIssue_issueNavigator"
        },
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            },
            {
              "kind": "ScalarField",
              "name": "startCursor"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraDetailedView"
};
})();

(node as any).hash = "20dfe27a9b90d825da94f2655f7aa52a";

export default node;
